import _defineProperty from "/var/lib/jenkins/workspace/yesep-ui/node_modules/@babel/runtime-corejs2/helpers/esm/defineProperty.js";
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '-50px'
    },
    position: {
      type: String,
      default: 'absolute'
    },
    left: {
      type: String,
      default: '0px'
    },
    marginLeft: {
      type: String,
      default: '0px'
    }
  },
  data: function data() {
    return {
      chart: 'chart10'
    };
  },
  mounted: function mounted() {// setTimeout(() => {
    //   this.initBarChart()
    // }, 1000)
    // this.$nextTick(() => {})
  },
  methods: {
    initBarChart: function initBarChart(title, color, date, a, length) {
      var _ref;

      //	得到仪表盘
      var titles = ['同比', '当前', '环比'];
      var axisLine = {
        show: false,
        lineStyle: {
          width: 10,
          shadowBlur: 0,
          color: [[0.2, '#6ff2c2'], [0.4, '#c2fb83'], [0.6, '#eadc57'], [0.8, '#fab272'], [1, '#ff776b']]
        }
      };
      var textStyle = {
        fontWeight: 'normal',
        fontSize: 16,
        color: '#0ff'
      };
      var axisLineZhou = {
        // 坐标轴线
        lineStyle: {
          color: [[0.66, '#dddddd'], [1, '#dddddd']],
          // 属性lineStyle控制线条样式
          width: 2
        }
      }; //仪表盘刻度

      var axisTicks = {
        show: true,
        lineStyle: {
          color: '#1b8586',
          width: 1
        },
        length: -5,
        splitNumber: 8
      };
      var splitLines = {
        show: true,
        length: -10,
        lineStyle: {
          color: '#1b8586'
        }
      };
      var zuoBiaoAxisLabel = {
        distance: -15,
        textStyle: {
          color: '#03B7C9',
          fontSize: '8'
        }
      };
      var details = {
        //表盘的数据,字体颜色也在这里进行修改
        show: false,
        offsetCenter: [0, '90%'],
        textStyle: {
          fontSize: 18,
          color: '#ff7705',
          padding: [20, 0, 0, 0]
        }
      };
      var Heightdetails = {
        //表盘的数据,字体颜色也在这里进行修改,高危部分的修改
        show: false,
        offsetCenter: [0, '90%'],
        textStyle: {
          fontSize: 18,
          color: '#ff7705'
        }
      };
      var myRate1 = 1000;
      var option = {
        title: [{
          x: '24%',
          bottom: '26%',
          text: title[0],
          textStyle: {
            'color': color[0]
          },
          textAlign: 'center',
          subtext: date[0] + '\n' + titles[0],
          subtextStyle: textStyle
        }, {
          x: '49%',
          bottom: '26%',
          text: title[1],
          textStyle: {
            'color': color[1]
          },
          textAlign: 'center',
          subtext: date[1] + '\n' + titles[1],
          subtextStyle: textStyle
        }, {
          x: '73%',
          bottom: '26%',
          text: title[2],
          textStyle: {
            'color': color[2]
          },
          textAlign: 'center',
          subtext: date[2] + '\n' + titles[2],
          subtextStyle: textStyle
        }],
        // backgroundColor: '#013954',
        series: [// 正确高危攻击区域
        {
          //高危攻击
          type: 'gauge',
          center: ['50%', '50%'],
          // 默认全局居中
          radius: '38%',
          splitNumber: length,
          //刻度数量
          min: 0,
          max: length,
          startAngle: 200,
          endAngle: -20,
          clockwise: true,
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              shadowBlur: 0,
              color: [[1, '#1b8586']]
            }
          },
          axisTick: axisTicks,
          splitLine: splitLines,
          axisLabel: zuoBiaoAxisLabel,
          pointer: {
            //仪表盘指针
            show: 0
          },
          detail: {
            show: false
          },
          data: [{
            name: '',
            value: 1
          }]
        }, {
          //高危攻击
          startAngle: 200,
          endAngle: -20,
          type: 'gauge',
          center: ['50%', '50%'],
          // 默认全局居中
          radius: '31%',
          min: 0,
          max: length,
          splitNumber: 0,
          axisLine: axisLineZhou,
          // 坐标轴线  ,
          axisLabel: {
            // 坐标轴小标记
            show: false
          },
          splitLine: {
            // 分隔线
            length: 10,
            // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              width: 0,
              color: '#444'
            }
          },
          pointer: {
            // 分隔线 指针
            color: '#666666',
            width: 0,
            length: 230
          },
          detail: {
            show: false
          }
        }, (_ref = {
          //高危攻击
          type: 'gauge',
          startAngle: 200,
          endAngle: -20,
          radius: '25%',
          center: ['50%', '50%'],
          // 默认全局居中
          min: 0,
          max: length,
          axisLine: axisLine,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            length: 20
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: true
          },
          detail: Heightdetails,
          itemStyle: {
            normal: {
              color: '#09c2c0'
            }
          }
        }, _defineProperty(_ref, "detail", {
          show: false
        }), _defineProperty(_ref, "data", [{
          value: a[1]
        }]), _ref), // 正确中危攻击区域
        {
          type: 'gauge',
          center: ['25%', '50%'],
          // 默认全局居中
          radius: '35%',
          splitNumber: length,
          //刻度数量
          min: 0,
          max: length,
          endAngle: 45,
          clockwise: true,
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              shadowBlur: 0,
              color: [[1, '#1b8586']]
            }
          },
          axisTick: axisTicks,
          splitLine: splitLines,
          axisLabel: zuoBiaoAxisLabel,
          pointer: {
            //仪表盘指针
            show: 0
          },
          detail: {
            show: false,
            textStyle: {
              // 其余属性默认使用全局文本样式，详见TEXTSTYLE
              color: '#f00',
              fontSize: 14
            }
          },
          data: [{
            name: '',
            value: myRate1
          }]
        }, {
          type: 'gauge',
          center: ['25%', '50%'],
          // 默认全局居中
          radius: '30%',
          min: 0,
          max: length,
          endAngle: 45,
          splitNumber: 0,
          axisLine: axisLineZhou,
          // 坐标轴线  ,
          axisLabel: {
            // 坐标轴小标记
            show: false
          },
          splitLine: {
            // 分隔线
            length: 10,
            // 属性length控制线长
            lineStyle: {
              // 属性lineStyle（详见lineStyle）控制线条样式
              width: 0,
              color: '#444'
            }
          },
          pointer: {
            // 分隔线 指针
            color: '#666666',
            width: 0,
            length: 230
          },
          detail: {
            show: false
          }
        }, {
          name: '中危攻击',
          type: 'gauge',
          endAngle: 45,
          radius: '25%',
          center: ['25%', '50%'],
          // 默认全局居中
          min: 0,
          max: length,
          axisLine: axisLine,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            length: 20
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: true,
            width: 5
          },
          detail: details,
          itemStyle: {
            normal: {
              color: '#09c2c0'
            }
          },
          data: [{
            value: a[0]
          }]
        }, //低危攻击区域
        {
          type: 'gauge',
          center: ['73%', '50%'],
          // 默认全局居中
          radius: '35%',
          splitNumber: length,
          //刻度数量
          min: 0,
          max: length,
          startAngle: 140,
          endAngle: -45,
          clockwise: true,
          axisLine: {
            show: true,
            lineStyle: {
              width: 2,
              shadowBlur: 0,
              color: [[1, '#1b8586']]
            }
          },
          axisTick: axisTicks,
          splitLine: splitLines,
          axisLabel: zuoBiaoAxisLabel,
          pointer: {
            //仪表盘指针
            show: 0
          },
          detail: {
            show: false
          },
          data: [{
            name: '',
            value: myRate1
          }]
        }, {
          type: 'gauge',
          center: ['73%', '50%'],
          // 默认全局居中
          radius: '30%',
          min: 0,
          max: length,
          startAngle: 140,
          endAngle: -45,
          splitNumber: 0,
          axisLine: axisLineZhou,
          // 坐标轴线  ,
          axisLabel: {
            // 坐标轴小标记
            show: false
          },
          splitLine: {
            // 分隔线
            show: false
          },
          pointer: {
            // 分隔线 指针
            color: '#666666',
            width: 0,
            length: 230
          },
          detail: {
            show: false
          }
        }, {
          name: '低危攻击',
          type: 'gauge',
          startAngle: 140,
          endAngle: -45,
          radius: '25%',
          center: ['73%', '50%'],
          // 默认全局居中
          min: 0,
          max: length,
          axisLine: axisLine,
          axisTick: {
            show: false
          },
          splitLine: {
            show: false,
            length: 20
          },
          axisLabel: {
            show: false
          },
          pointer: {
            show: true,
            width: 5
          },
          detail: details,
          itemStyle: {
            normal: {
              color: '#09c2c0'
            }
          },
          data: [{
            value: a[2]
          }]
        }]
      };
      var chart = this.$refs[this.chart];
      var myChart = this.$echarts.init(chart);
      myChart.setOption(option);

      window.onresize = function () {
        myChart.resize();
      };
    }
  }
};